import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"

const addReceiptSetting = (receipt_series) => {
  return axios.post(API + "company/company-settings/", {
    receipt_series,

  
  },{headers: authHeader(),});
};
const AddReceiptSettingService = {
    addReceiptSetting,
    
  };
  export default AddReceiptSettingService;